import { ReactElement, useState } from 'react'
import { useModal, create } from '@ebay/nice-modal-react'
import { SimpleModal } from '../../../ui-components/modals/SimpleModal'
import { useSpecificConditionStore } from '../../../store/specificConditions/SpecificConditionsStore'
import styled from 'styled-components'
import { RadioGroup } from '../../../ui-components/forms/RadioGroup'
import { SpecificConditionI } from '../../../store/models/SpecificConditions'
import { observer } from 'mobx-react-lite'
import { IdValuePair } from 'interfaces'

interface ISpecificConditionsModalProps {
  proceed: () => void
  cancel?: () => void
}

export const SpecificConditionsModal = create<ISpecificConditionsModalProps>(
  observer(
    ({ proceed, cancel }: ISpecificConditionsModalProps): ReactElement => {
      const {
        specificConditionQuestions: questions,
        areAllQuestionsAnswered,
        findQuestion,
        processQuestions,
      } = useSpecificConditionStore()

      const modal = useModal()

      const [enableButton, setEnableButton] = useState(
        areAllQuestionsAnswered()
      )

      const handleGo = () => {
        processQuestions()
        proceed()
        modal.remove()
      }

      const handleCancel = () => {
        if (cancel) {
          cancel()
        }
        modal.remove()
      }

      const onAnswerEvent = (
        question: SpecificConditionI,
        answer: IdValuePair<string>
      ): void => {
        findQuestion(question).choice = answer
        setEnableButton(areAllQuestionsAnswered())
      }

      return (
        <SimpleModal
          title="fitmentConditions"
          primaryActionText="go"
          secondaryActionText="back"
          onPrimaryAction={handleGo}
          onSecondaryAction={handleCancel}
          disablePrimaryButton={!enableButton}
          show={modal.visible && questions.length > 0}
        >
          <Wrapper>
            {questions.map((question) => {
              return (
                <div key={question.id}>
                  <QuestionAnswersWrapper>
                    <QuestionWrapper>{question.value}</QuestionWrapper>
                    <AnswersWrapper>
                      <RadioGroup
                        id={`${question.id} _ ${question.value}`}
                        name={question.value}
                        options={question.choices}
                        initialValue={question.choice?.id}
                        onChange={(selected: IdValuePair<string>): void => {
                          onAnswerEvent(question, selected)
                        }}
                      />
                    </AnswersWrapper>
                  </QuestionAnswersWrapper>
                </div>
              )
            })}
          </Wrapper>
        </SimpleModal>
      )
    }
  )
)

const Wrapper = styled.div`
  padding-top: 1rem;
`

const QuestionAnswersWrapper = styled.div`
  padding-bottom: 2rem;
`

const QuestionWrapper = styled.div`
  font-family: Roboto, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: #050505;
  mix-blend-mode: normal;
  opacity: 0.9;
`
const AnswersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Roboto, serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #050505;
  padding-top: 0.5rem;
`
